import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser, resetUserState, getAllUsers, selectUsersLoading, selectUsersSuccess, selectUsersError, selectUsersMessage } from '../../features/users/userSlice';
import { useToast } from '../../contexts/ToastContext';
import UserForm from './UserForm';
import LoadingSpinner from '../ui/LoadingSpinner';

function EditUser({ user, onCancel, onSuccess }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectUsersLoading);
  const isSuccess = useSelector(selectUsersSuccess);
  const isError = useSelector(selectUsersError);
  const message = useSelector(selectUsersMessage);
  const toast = useToast();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  
  // Reset state when component mounts
  useEffect(() => {
    dispatch(resetUserState());
    setHasSubmitted(false);
  }, [dispatch]);
  
  useEffect(() => {
    // Only handle success/error if we actually submitted a form
    if (hasSubmitted) {
      if (isSuccess) {
        toast.showSuccess('User updated successfully');
        dispatch(resetUserState());
        setHasSubmitted(false);
        // Refresh the users list in the background
        dispatch(getAllUsers());
        onSuccess();
      }
      
      if (isError && message) {
        toast.showError(message);
        setHasSubmitted(false); // Reset so user can try again
      }
    }
  }, [isSuccess, isError, message, dispatch, toast, onSuccess, hasSubmitted]);
  
  // Handle form submission
  const handleSubmit = (userData) => {
    setHasSubmitted(true);
    dispatch(updateUser({ userId: user.id, userData }));
  };
  
  // Handle cancel - reset state and navigate back
  const handleCancel = () => {
    dispatch(resetUserState());
    setHasSubmitted(false);
    onCancel();
  };
  
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 relative">
 
      
      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-lg">
          <div className="flex flex-col items-center">
            <LoadingSpinner />
            <p className="mt-2 text-sm text-gray-600">Updating user...</p>
          </div>
        </div>
      )}
      
      {/* Form Body */}
      <div className="p-6">
        <UserForm 
          user={user}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}

export default EditUser;
